var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2351 0H9.11613C8.69595 0 8.10751 0.24374 7.81074 0.540512L0.2242 8.12705C0.153123 8.19808 0.096739 8.28242 0.0582697 8.37525C0.0198005 8.46809 0 8.56759 0 8.66807C0 8.76856 0.0198005 8.86806 0.0582697 8.96089C0.096739 9.05372 0.153123 9.13806 0.2242 9.20909L6.79091 15.7758C6.86194 15.8469 6.94628 15.9033 7.03911 15.9417C7.13194 15.9802 7.23144 16 7.33193 16C7.43241 16 7.53191 15.9802 7.62475 15.9417C7.71758 15.9033 7.80192 15.8469 7.87295 15.7758L15.4595 8.18926C15.7573 7.89147 16 7.30405 16 6.88387V0.764875C16 0.562017 15.9194 0.367469 15.776 0.224027C15.6325 0.0805848 15.438 0 15.2351 0ZM11.4108 6.119C11.2098 6.11893 11.0108 6.07928 10.8252 6.00232C10.6396 5.92536 10.4709 5.81258 10.3288 5.67044C10.1868 5.52829 10.0741 5.35956 9.99729 5.17387C9.92045 4.98819 9.88093 4.78919 9.881 4.58823C9.88107 4.38727 9.92072 4.1883 9.99768 4.00266C10.0746 3.81703 10.1874 3.64837 10.3296 3.50632C10.4717 3.36427 10.6404 3.25161 10.8261 3.17477C11.0118 3.09793 11.2108 3.05841 11.4118 3.05848C11.8176 3.05861 12.2068 3.21997 12.4937 3.50704C12.7806 3.79412 12.9417 4.1834 12.9415 4.58925C12.9414 4.9951 12.78 5.38427 12.493 5.67116C12.2059 5.95804 11.8166 6.11913 11.4108 6.119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.b3f682e958e2e7c7b20428d5499c4397.svg";
export { ForwardRef as ReactComponent };